"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileProcessorEventBus = void 0;
var debounce_1 = __importDefault(require("lodash/debounce"));
var processingUtils_1 = require("../util/processingUtils");
var eventBus_1 = __importDefault(require("../util/eventBus"));
var uploadStateEnum_1 = require("./uploadStateEnum");
var fileModel_1 = __importDefault(require("./fileModel"));
var FileProcessorEventBus = /** @class */ (function (_super) {
    __extends(FileProcessorEventBus, _super);
    function FileProcessorEventBus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FileProcessorEventBus;
}(eventBus_1.default));
exports.FileProcessorEventBus = FileProcessorEventBus;
var FileProcessor = /** @class */ (function () {
    function FileProcessor(uploadManager, store) {
        var _this = this;
        this.uploadManager = uploadManager;
        this.store = store;
        this.state = uploadStateEnum_1.PROCESSING_STATES.INACTIVE;
        this.filesUploaded = new Array();
        // private tags = new Array();
        this.files = new Array();
        this.eventBus = new FileProcessorEventBus();
        this._uploadImagesDebounced = (0, debounce_1.default)(function (waitForProcessing) {
            if (waitForProcessing === void 0) { waitForProcessing = true; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._uploadImages(waitForProcessing)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }, 1000, true);
    }
    FileProcessor.prototype._setProcessing = function (state) {
        this.state = state;
        this.store.dispatch("fileUpload/setProcessingState", state);
    };
    FileProcessor.prototype._clear = function () {
        this.filesUploaded = this.files;
        this.files = this.files.filter(function (f) { return f.state === uploadStateEnum_1.FILE_STATUS.UPLOAD_FAILED; });
        this._setProcessing(uploadStateEnum_1.PROCESSING_STATES.INACTIVE);
    };
    FileProcessor.prototype._getNextFile = function () {
        return this.files.find(function (o) { return o.state === uploadStateEnum_1.FILE_STATUS.STATIC; });
    };
    // private _setTags() {
    //   if (this.tags.length > 0 && this.filesUploaded.length > 0) {
    //     let fileids = this.filesUploaded.map(file => file.fileid);
    //     let uniqueTags = uniq(this.tags);
    //     this.uploadManager.setImageTags(fileids, uniqueTags);
    //   }
    // }
    // private _uploadInProject() {
    //   return (
    //     this.store.state.project.selectedProjectId != null &&
    //     !this.store.state.media.selectForAttachment
    //   );
    // }
    // private async _updateVersioning() {
    //   const filesToUpdate = this.filesUploaded.filter(
    //     file => file.oldFileId && file.state == FILE_STATUS.FILE_PROCESSED,
    //   );
    //   //console.log('_updateVersioning::filesToUpdate', filesToUpdate)
    //   const selectedProjectId = this.store.state.project.selectedProjectId;
    //   //console.log(`_updateVersioning:: selectedProjectId: ${selectedProjectId}`)
    //   // TBD
    //   if (this._uploadInProject()) {
    //     if (filesToUpdate.length > 0) {
    //       for (let i = 0, c = filesToUpdate.length; i < c; i++) {
    //         let { fileid, oldFileId } = filesToUpdate[i];
    //         await this.uploadManager.VersionFilebyUploadId(
    //           selectedProjectId,
    //           fileid,
    //           oldFileId,
    //         );
    //         await this.store.dispatch("comments/postNewVersion", {
    //           projectId: selectedProjectId,
    //           newFileId: fileid,
    //           oldFileId,
    //         });
    //         this.eventBus.$emit(FILE_UPLOAD_EVENTS.FILE_VERSION_UPDATED, fileid);
    //       }
    //       await this.uploadManager.refreshViewsByFilesIds(
    //         this.filesUploaded.map(f => f.fileid),
    //       );
    //     } else {
    //       const similarFiles = this.filesUploaded
    //         .filter(file => !!file.similarFile)
    //         .map(file => file.similarFile);
    //       if (similarFiles.length) {
    //         this.store.dispatch("uploadStore/addSimilars", similarFiles);
    //       } else {
    //         await this.uploadManager.refreshViewsByFilesIds(
    //           this.filesUploaded.map(f => f.fileid),
    //         );
    //       }
    //     }
    //   } else {
    //     await this.uploadManager.refreshViewsByFilesIds(
    //       this.filesUploaded.map(f => f.fileid),
    //     );
    //   }
    // }
    // private async _updateProjectImages() {
    //   if (!this._uploadInProject()) return;
    //   const selectedProjectId = this.store.state.project.selectedProjectId;
    //   const processedFiles = this.filesUploaded.filter(
    //     file =>
    //       file.oldFileId == null && file.state == FILE_STATUS.FILE_PROCESSED,
    //   );
    //   this.store.dispatch("project/addImages", {
    //     files: processedFiles,
    //     projectId: selectedProjectId,
    //   });
    //   await this._postUploadNewFiles(processedFiles, selectedProjectId);
    //   if (selectedProjectId) {
    //     const project = this.store.state.project.allProjects.find(
    //       (p: any) => p.id == selectedProjectId,
    //     );
    //     if (
    //       project &&
    //       project.jobDetails &&
    //       !project.confirmedProjectActive &&
    //       project.imageCount + processedFiles.length >= 2 &&
    //       this.store.state.comments.commentsData.allComments.length >= 5
    //     ) {
    //       this.store.$userActivity.publishProjectIsActive(selectedProjectId);
    //     }
    //   }
    //   this.store.$GTMService.pageView("Files uploaded");
    // }
    // private async _postUploadNewFiles(
    //   processedFiles: FileModel[],
    //   projectId: number | null,
    // ) {
    //   const similarNewFileIds = this.store.state.uploadStore.similars.map(
    //     (s: any) => s.newFileId,
    //   );
    //   let newFileIds = processedFiles
    //     .map((o: any) => o.fileid)
    //     .filter((id: any) => !similarNewFileIds.includes(id));
    //   const hasSimilars = processedFiles.length > newFileIds.length;
    //   // exclude attachments for autopost event
    //   const attachments =
    //     this.store.state.attachments.newCommentAttachments || [];
    //   if (attachments.length) {
    //     newFileIds = newFileIds.filter(
    //       (id: any) => !attachments.some((x: any) => x.fileId == id),
    //     );
    //     this.store.dispatch("media/clearItemSelected");
    //   }
    //   newFileIds.forEach((fileId: any) => {
    //     this.store.commit("uploadStore/addNewFile", { projectId, fileId });
    //   });
    //   if (!hasSimilars && newFileIds.length) {
    //     await delay(1000); // give azure blob storage a bit of time
    //     this.store.dispatch("uploadStore/postUploadNewFiles");
    //   }
    // }
    FileProcessor.prototype._publishFilesUploaded = function () {
        var fileUploadedCount = this.files.filter(function (file) { return file.state == uploadStateEnum_1.FILE_STATUS.FILE_UPLOADED; }).length;
        var fileCount = this.files.length;
        this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.FILES_UPLOADED, {
            fileCount: fileCount,
            fileUploadedCount: fileUploadedCount,
        });
    };
    FileProcessor.prototype._checkResizeStatus = function (checkResizeStatusCount) {
        if (checkResizeStatusCount === void 0) { checkResizeStatusCount = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var workingFile, filesUploaded, uploadIds, processedImageIds, successfullyProcessedIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        workingFile = this._getNextFile();
                        filesUploaded = this.files.filter(function (file) { return file.state === uploadStateEnum_1.FILE_STATUS.FILE_UPLOADED; });
                        if (!workingFile) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._uploadImages(true)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 14];
                    case 2:
                        if (!(filesUploaded.length > 0)) return [3 /*break*/, 13];
                        if (!(checkResizeStatusCount < 60)) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0, processingUtils_1.delay)(500)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 4:
                        if (!(checkResizeStatusCount < 120)) return [3 /*break*/, 6];
                        return [4 /*yield*/, (0, processingUtils_1.delay)(1000)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 6:
                        if (!(checkResizeStatusCount < 180)) return [3 /*break*/, 8];
                        return [4 /*yield*/, (0, processingUtils_1.delay)(2000)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, (0, processingUtils_1.delay)(3000)];
                    case 9:
                        _a.sent();
                        _a.label = 10;
                    case 10:
                        this._setProcessing(uploadStateEnum_1.PROCESSING_STATES.PROCESSING_IMAGES);
                        uploadIds = filesUploaded
                            .filter(function (file) { return file.uploadId; })
                            .map(function (file) { return file.uploadId || 0; });
                        return [4 /*yield*/, this.uploadManager.checkResizeStatus(uploadIds)];
                    case 11:
                        processedImageIds = _a.sent();
                        if (processedImageIds) {
                            processedImageIds
                                .map(function (id) { return id.uploadId; })
                                .forEach(function (uid) {
                                var index = _this.files.findIndex(function (o) { return o.uploadId == uid; });
                                if (index !== -1) {
                                    _this.files[index].polled();
                                    _this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.IMAGE_POLLED, _this.files[index]);
                                }
                            });
                            successfullyProcessedIds = processedImageIds
                                .filter(function (processed) {
                                return processed.complete &&
                                    processed.success &&
                                    processed.PreviewsGenerated;
                            })
                                .map(function (processed) { return processed.uploadId; });
                            if (successfullyProcessedIds.length > 0) {
                                this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.PROCESSED_IMAGE_IDS, successfullyProcessedIds);
                                // const mediaItems = await this.store.dispatch(
                                //   "media/addUploadedImages",
                                //   {
                                //     imageIdArray: successfullyProcessedIds,
                                //     userLoggedIn: !this.store.getters["account/isAnonymous"],
                                //   },
                                // );
                                // HV3-1619
                                // const firstImage = mediaItems[0]?.image || null;
                                // if (firstImage) {
                                //   const selectedProject =
                                //     this.store.getters["project/selectedProject"];
                                //   if (selectedProject && !selectedProject.image) {
                                //     this.store.commit("project/updateCoverImage", {
                                //       projectId: selectedProject.id,
                                //       image: firstImage,
                                //     });
                                //   }
                                // }
                                successfullyProcessedIds.forEach(function (uid) {
                                    var index = _this.files.findIndex(function (o) { return o.uploadId == uid; });
                                    if (index !== -1) {
                                        var fileModel = _this.files[index];
                                        // const mediaItem = mediaItems.find(
                                        //   (x: any) => x.image.id == fileModel.fileid,
                                        // );
                                        fileModel.processed();
                                        _this.store.dispatch("fileUpload/updateFile", fileModel);
                                        _this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.PROCESSED_IMAGE, fileModel);
                                    }
                                });
                            }
                        }
                        return [4 /*yield*/, this._checkResizeStatus(checkResizeStatusCount + 1)];
                    case 12:
                        _a.sent();
                        return [3 /*break*/, 14];
                    case 13:
                        this.finishUpload(true);
                        _a.label = 14;
                    case 14: return [2 /*return*/];
                }
            });
        });
    };
    FileProcessor.prototype._uploadImages = function (waitForProcessing) {
        if (waitForProcessing === void 0) { waitForProcessing = true; }
        return __awaiter(this, void 0, void 0, function () {
            var workingFile;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._setProcessing(uploadStateEnum_1.PROCESSING_STATES.UPLOADING_IMAGES);
                        workingFile = this._getNextFile();
                        _a.label = 1;
                    case 1:
                        if (!workingFile) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.uploadManager.uploadFile(workingFile, function (fileModel) {
                                _this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.FILE_UPLOADING, fileModel);
                                _this.store.dispatch("fileUpload/updateFile", fileModel);
                            })];
                    case 2:
                        _a.sent();
                        workingFile = this._getNextFile();
                        return [3 /*break*/, 1];
                    case 3:
                        this._publishFilesUploaded();
                        if (!waitForProcessing) return [3 /*break*/, 5];
                        return [4 /*yield*/, this._checkResizeStatus()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.finishUpload(false);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    FileProcessor.prototype._mapFiles = function (files, fileStatus, systemUser) {
        if (systemUser === void 0) { systemUser = ""; }
        // const selectedProjectId = this.store.state.media.selectForAttachment
        //   ? null
        //   : this.store.state.project.selectedProjectId;
        // const selectedBucketId =
        //   this.store.state.buckets.selectedBucketId ||
        //   this.store.state.buckets.selectedBucketCardIds[0];
        var fileWhiteList = this.store.state.global.configs.fileWhiteList;
        var mappedFiles = new (Array.bind.apply(Array, __spreadArray([void 0], files, false)))().map(function (file) {
            return new fileModel_1.default(file, 
            // selectedProjectId,
            // selectedBucketId,
            fileStatus, fileStatus === uploadStateEnum_1.FILE_STATUS.FILE_UPLOADED &&
                file.uploadId &&
                !isNaN(file.uploadId)
                ? file.uploadId
                : null, systemUser);
        })
            .filter(function (fileModel) { return fileModel.isValid(fileWhiteList); })
            .sort(function (fileModel) { return fileModel.file.name; });
        return mappedFiles;
    };
    FileProcessor.prototype.cancelFile = function (file) {
        var index = this.files.findIndex(function (o) { return o.id == file.id; });
        this.files[index].cancel();
        this.store.dispatch("fileUpload/updateFile", this.files[index]);
        this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.FILE_CANCELLED, this.files[index]);
    };
    FileProcessor.prototype.retryFile = function (file) {
        var index = this.files.findIndex(function (o) { return o.id == file.id; });
        if (index !== -1) {
            this.files[index].reset();
            this.store.dispatch("fileUpload/updateFile", this.files[index]);
        }
        if (this.state === uploadStateEnum_1.PROCESSING_STATES.INACTIVE) {
            this._uploadImagesDebounced();
        }
    };
    FileProcessor.prototype.cancelAll = function () {
        this._setProcessing(uploadStateEnum_1.PROCESSING_STATES.INACTIVE);
        var filesToCancel = this.files.filter(function (fileModel) { return fileModel.state === uploadStateEnum_1.FILE_STATUS.STATIC; });
        for (var i = 0, c = filesToCancel.length; i < c; i++) {
            filesToCancel[i].cancel();
            this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.FILE_CANCELLED, filesToCancel[i]);
        }
    };
    FileProcessor.prototype.reprocess = function (fileId, systemUser) {
        this.uploadManager.reprocess(fileId, systemUser);
    };
    FileProcessor.prototype.addFilesAndDontWaitForProcessing = function (files, fileStatus, systemUser) {
        if (systemUser === void 0) { systemUser = ""; }
        this.addFiles(files, fileStatus, false, systemUser);
    };
    FileProcessor.prototype.addFiles = function (files, fileStatus, waitForProcessing, systemUser) {
        var _a;
        if (waitForProcessing === void 0) { waitForProcessing = true; }
        if (systemUser === void 0) { systemUser = ""; }
        var mappedFiles = this._mapFiles(files, fileStatus, systemUser);
        (_a = this.files).push.apply(_a, mappedFiles);
        var vuexFiles = mappedFiles.map(function (fileModel) { return fileModel.getVM(); });
        this.store.dispatch("fileUpload/addFiles", vuexFiles);
        if (this.state == uploadStateEnum_1.PROCESSING_STATES.INACTIVE) {
            this._uploadImagesDebounced(waitForProcessing);
        }
        // this.store.$GTMService.buttonClick("Files added for upload");
    };
    // setTags(newTags: any[]) {
    //   this.tags.push(...newTags);
    //   if (this.state === PROCESSING_STATES.INACTIVE) {
    //     this._setTags();
    //   }
    // }
    FileProcessor.prototype.finishUpload = function (waitedForProcessing) {
        this._clear();
        if (waitedForProcessing) {
            this.eventBus.$emit(uploadStateEnum_1.FILE_UPLOAD_EVENTS.ALL_FILES_PROCESSED, this.filesUploaded.length);
        }
        // this._setTags();
        // this._updateVersioning();
        // this._updateProjectImages();
        this.filesUploaded = [];
        // this.tags = [];
    };
    return FileProcessor;
}());
exports.default = FileProcessor;
//# sourceMappingURL=fileProcessor.js.map